import type { SystemStyleObject } from '@chakra-ui/system';

/**
 * Material-library suggestion assistance UI (icons, in-menu sparkle).
 * Kept in the app module so the design-system cascader config stays feature-agnostic.
 */
export const materialSuggestionCascaderStyles = {
  /** In-flow sparkle in menu rows (label → icon → chevron / search path). */
  optionSuggestionIconInline: {
    boxSize: 3,
    flexShrink: 0,
  } satisfies SystemStyleObject,
  /** Control field: available / approved assistance state. */
  suggestionsAvailableIcon: {
    boxSize: 3,
    color: 'alert.assistance',
  } satisfies SystemStyleObject,
  /** Control field: rejected assistance state. */
  suggestionsRejectedIcon: {
    boxSize: 3,
    color: 'feature.placeholder',
  } satisfies SystemStyleObject,
} as const;
